<template>
	<div>
		<div v-if="isDraftContractSigned">
			{{$t('digital.confirm.contractsigned.label')}}
		</div>
		<div v-else>
			<div v-if="isDraftContractPaid">
				<modal id="send-email-modal">
			        <div class="modal-container with-table" slot="modal-container">
			        	<div class="close" v-on:click="$router.go(-1)">
	                         <SvgIcon icon="close" />
	                    </div>
			            <h2>{{$t('modal.send-email.headline')}}</h2>
			            <p class="bold">{{$t('modal.send-email.text')}}</p>
			            <div class="modal-table">
			            	<p class="label-name">{{$t('modal.send-email.tenant.label')}}</p>
			            	<div v-for="tenant in tenants" class="item">
			            		<div class="name">
			            			<span class="icon">
				                        <SvgIcon icon="avatar" />
				                    </span>
			            			<p v-if="tenant.name">{{ tenant.name }}</p>
			            			<p v-else>{{$t('modal.send-email.tenant.no-name')}}</p>
			            		</div>
			            		<div class="email">
			            			<p>{{ tenant.email }}</p>
			            		</div>
			            	</div>

			           		<p class="label-name">{{$t('tenant-contracts.landlord.label')}}</p>
			            	<div class="item">
			            		<div class="name">
			            			<span class="icon">
				                        <SvgIcon icon="avatar" />
				                    </span>
			            			<p>{{ landlord.name }}</p>
			            		</div>
			            		<div class="email">
			            			<p>{{ landlord.email }}</p>
			            		</div>
			            	</div>
			            </div>
			            <div>
			            	<label class="custom-checkbox">
                            <input type="checkbox" v-model="termsAccepted">
                                <span class="checkbox">
                                    <SvgIcon icon="checkmark-input" />
                                </span>
                                <div class="text"><p>{{$t('register.accept-terms.text')}} <a target="_blank" href="https://www.rently.dk/terms/"> {{$t('register.accept-terms.link')}}</a></p></div>
                            </label>
                            <p class="comment">
                            	{{$t('modal.send-email.comment-text')}}
                            </p>
			            </div>

			            <button class="purple":disabled="sendingEmail || !termsAccepted" @click.prevent="confirm()">
				            <span v-if="sendingEmail">{{$t('digital.tabs.sending')}} ...</span>
				            <span v-if="!sendingEmail">{{$t('digital.tabs.review.send-email')}}</span>
			            </button>

			        </div>
			    </modal>
			</div>
			<div v-else id="abonnement" class="inner" style="padding-top: 0;">
				<OrderProcess :product="2" :params="getPaymentBinds" v-on:completed="completed()" />
			</div>
		</div>
	</div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {store} from '../../store/index';

    import OrderProcess from '../../components/OrderProcess.vue';
    import Modal from '../../components/Modal';
    import SvgIcon from '../../components/Svg.vue';

	export default {
		data: () => ({
			termsAccepted: false,
			sendingEmail: false,
			tenants: [],
			landlord: {
				name: '',
				email: ''
			}
		}),
		components: {
			Modal,
			SvgIcon,
			OrderProcess
		},
		computed: {
			...mapGetters([
				'getToken',
				'getSingleDraftContractEmail',
				'isDraftContractPaid',
				'isDraftContractSent',
				'isDraftContractSigned'
			]),
			getPaymentBinds() {
				return {
					'contractId': this.$route.params.id
				};
			}
		},
		methods: {
			completed() {
				this.$router.go(0);
			},
			load() {
				axios({
                    method: 'GET',
                    url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id + '/send',
					cancelToken: window.AuthorizationCancelSource.token,
                }).then(response => {
                    this.landlord = response.data.landlord;
                    this.tenants = response.data.tenants;
                });
			},
			confirm() {
				var self = this;
				this.sendingEmail = true;
				axios({
                    method: 'POST',
                    url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id + '/send',
					cancelToken: window.AuthorizationCancelSource.token,
                    data:{
                        email: this.getSingleDraftContractEmail
                    }
                }).then(response => {
                    self.$store.commit('setSuccessBarMessage', self.$t('successbar.digital-contract.signatureemailsent.message'));
                    self.sendingEmail = false;
                    this.$router.push('/contracts');
                    // this.$router.push('/contracts/digital-contract/edit/' + this.$route.params.id);
                }).finally(e => {
                    self.sendingEmail = false;
                });
            }
		},
		created() {
			this.$store.commit('setCreditCardRedirection', '/contracts/digital-contract/confirm/'+this.$route.params.id);
			this.$store.dispatch('fetchSingleDraftContract', {
				id: this.$route.params.id
			});
			this.load();
		}
	}
</script>
